import React, { useEffect, useState } from "react";
import styles from "./style.module.css";
import Header from "../../partials/ExternalHeader";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import { notification, Spin } from "antd";
import back from "../../../images/back-white.png";
const PickupExternalOrder = () => {
  let navigate = useNavigate();
  const url = process.env.REACT_APP_APP_BACK_URL;
  const { id, slug } = useParams();
  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);
  const lock3rOpen = queryParams.get("lockerOpen");
  const react_base_url = process.env.REACT_APP_BASE_URL;
  const [isNotFound, setIsNotFound] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [lockerBusy, setLockerBusy] = useState(false);
  const [lockerBusyTip, setLockerBusyTip] = useState("");
  const [disableConfirmButton, setDisableConfirmButton] = useState(
    lock3rOpen ? true : false
  );
  const [credentials, setCredentials] = useState({
    _id: "",
    order_number: "",
    pickup_code: "",
    locker_id: "",
    locker_number: "",
    locker_relay: "",
    user_name: "",
    user_email: "",
    customer_name: "",
    customer_email: "",
    has_door: "",
    site_url: "",
    site_relay: "",
    status: "",
    createdAt: "",
    updatedAt: "",
  });
  useEffect(() => {
    fetchData();
  }, []);

  let idleTimer;
  let idleTimeoutInSeconds = 15; // 5 minutes (adjust as needed)
  useEffect(() => {
    resetIdleTimer();
    const activityEvents = ["mousemove", "keydown", "mousedown", "scroll"];
    const onActivity = () => {
      resetIdleTimer();
    };
    activityEvents.forEach((event) => {
      window.addEventListener(event, onActivity);
    });
    return () => {
      activityEvents.forEach((event) => {
        window.removeEventListener(event, onActivity);
      });
    };
  }, []);
  const resetIdleTimer = () => {
    clearTimeout(idleTimer);
    idleTimer = setTimeout(handle_logout, idleTimeoutInSeconds * 1000);
  };
  // Function to simulate a logout action
  const handle_logout = async (e) => {
    // if (getSite.required_pin) {
    //   const logouts = await localStorage.removeItem("token");
    //   // dispatch(logout());
    // }
    // navigate(`/${slug}/pin`);
  };

  const fetchData = async () => {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("Access-Control-Allow-Origin", "*");
    headers.append("Access-Control-Allow-Credentials", "true");
    headers.append("auth-token", localStorage.getItem("token"));
    setIsLoading(true);
    setIsNotFound(false);
    try {
      const response = await fetch(`${url}/api/pickups/${id}`, {
        mode: "cors",
        method: "GET",
        headers: headers,
      });
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const json = await response.json();
      if (json.success) {
        setCredentials({ ...json.pickup });
        idleTimeoutInSeconds = json.time;
      } else {
        setIsNotFound(true);
        idleTimeoutInSeconds = json.time;
      }
    } catch (error) {
      console.error(error);
      setIsNotFound(true);
    } finally {
      setIsLoading(false);
    }
  };
  // const handleConfirmPickup = async () => {
  //   try {
  //     const result = await Swal.fire({
  //       title: "Please confirm",
  //       text: "You have pickup the order",
  //       icon: "warning",
  //       showCancelButton: true,
  //       confirmButtonText: "Yes, I confirm",
  //       cancelButtonText: "No, cancel",
  //       reverseButtons: true,
  //     });
  //     if (result.isConfirmed) {
  //       navigate(`/${slug}/pin`);
  //     }
  //   } catch (error) {
  //     console.error(error);
  //   }
  // };
  const HandleConfirmPickup = async (iid) => {
    try {
      const result = await Swal.fire({
        title: "Please confirm",
        text: "You have pickup the order",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, I confirm",
        cancelButtonText: "No, cancel",
        reverseButtons: true,
      });
      if (result.isConfirmed) {
        const state = "2";
        setLockerBusy(true);
        setLockerBusyTip("Completing pickup…");
        try {
          const headers = new Headers();
          headers.append("Content-Type", "application/json");
          headers.append("Access-Control-Allow-Origin", "*");
          headers.append("Access-Control-Allow-Credentials", "true");

          const response = await fetch(
            `${url}/api/lockers/openLockerAndConfirmPickup`,
            {
              mode: "cors",
              method: "POST",
              headers: headers,
              body: JSON.stringify({
                id: iid,
                state: state,
                pickupId: id,
                base_url: react_base_url,
              }),
            }
          );

          const json = await response.json();
          if (json.success) {
            notification.success({
              message: "Success",
              description: json.alreadyCompleted
                ? json.message || "Pickup was already completed."
                : "Pickup Complete Successfuly",
              duration: 3,
            });
            setCredentials((prev) => ({ ...prev, status: "completed" }));
            setTimeout(() => {
              navigate(`/${slug}/pin`);
            }, 2000);
          } else {
            notification.error({
              message: "Unable to complete pickup",
              description: lockerErrorText(json),
              duration: 6,
            });
          }
        } catch (err) {
          console.error(err);
          notification.error({
            message: "Unable to complete pickup",
            description:
              "We could not complete this pickup. Please try again or ask a staff member for help.",
            duration: 6,
          });
        } finally {
          setLockerBusy(false);
          setLockerBusyTip("");
        }
      }
    } catch (error) {
      setLockerBusy(false);
      setLockerBusyTip("");
      console.error(error);
    }
  };
  const lockerErrorText = (payload) => {
    const raw = String(payload?.message || payload?.error || "").trim();
    return raw || "We could not open the locker. Please try again.";
  };
  const HandleOpenLocker = async (locker_id) => {
    const state = "2";
    setLockerBusy(true);
    setLockerBusyTip("Opening locker…");
    try {
      const headers = new Headers();
      headers.append("Content-Type", "application/json");
      headers.append("Access-Control-Allow-Origin", "*");
      headers.append("Access-Control-Allow-Credentials", "true");
      const response = await fetch(`${url}/api/lockers/relay/state/update`, {
        mode: "cors",
        method: "POST",
        headers: headers,
        body: JSON.stringify({
          id: locker_id,
          state: state,
        }),
      });
      const json = await response.json();
      if (json.success) {
        setDisableConfirmButton(true);
        const confirmHeaders = new Headers();
        confirmHeaders.append("Content-Type", "application/json");
        confirmHeaders.append("Access-Control-Allow-Origin", "*");
        confirmHeaders.append("Access-Control-Allow-Credentials", "true");
        try {
          const confirmRes = await fetch(
            `${url}/api/lockers/openLockerAndConfirmPickup`,
            {
              mode: "cors",
              method: "POST",
              headers: confirmHeaders,
              body: JSON.stringify({
                id: locker_id,
                state,
                pickupId: id,
                base_url: react_base_url,
              }),
            }
          );
          const confirmJson = await confirmRes.json();
          if (confirmJson.success) {
            const desc =
              confirmJson.message ||
              "Locker opened and pickup completed successfully.";
            notification.success({
              message: "Success",
              description: desc,
              duration: 4,
            });
            setCredentials((prev) => ({ ...prev, status: "completed" }));
          } else {
            notification.warning({
              message: "Locker opened",
              description:
                lockerErrorText(confirmJson) ||
                "The locker opened, but the pickup could not be completed. Please use Confirm Pickup.",
              duration: 6,
            });
          }
        } catch (completeErr) {
          console.error(completeErr);
          notification.warning({
            message: "Locker opened",
            description:
              "The locker opened, but we could not confirm the pickup. Please use Confirm Pickup.",
            duration: 6,
          });
        }
      } else {
        notification.error({
          message: "Unable to open locker",
          description: lockerErrorText(json),
          duration: 6,
        });
      }
    } catch (error) {
      console.error(error);
      notification.error({
        message: "Unable to open locker",
        description:
          "We could not reach the locker. Please check your connection and try again.",
        duration: 6,
      });
    } finally {
      setLockerBusy(false);
      setLockerBusyTip("");
    }
  };
  return (
    <div className={styles.heading}>
      <div className="body-wrap">
        <div className="container-fluid px-0">
          <Header />
          <div className={styles.body_wrap}>
            <div
              className={`login-container ${styles.externalPickupLogin}`}
            >
              <div className="row justify-content-center w-100 mx-0">
                <div className="col-12 px-2 px-sm-3">
                  {isLoading ? (
                    <div
                      className={`form-box card-box ${styles.externalOrderCard}`}
                      style={{ padding: 0 }}
                    >
                      <div className={styles.externalPageLoader}>
                        <Spin size="large" tip="Loading pickup details…" />
                      </div>
                    </div>
                  ) : isNotFound ? (
                    <div className={styles.externalNotFound}>
                      <div className={styles.externalNotFoundTitle}>
                        Pickup not available
                      </div>
                      <p className={styles.externalNotFoundText}>
                        This pickup may already be complete, or the link is
                        invalid. Please verify your pickup code or contact the
                        site for help.
                      </p>
                    </div>
                  ) : (
                    <div
                      className={`form-box card-box ${styles.externalOrderCard}${
                        disableConfirmButton
                          ? ` ${styles.externalOrderCardOpened}`
                          : ""
                      }`}
                      style={{ padding: 0 }}
                    >
                      <div className={styles.externalOrderHeader}>
                        <div className={styles.externalOrderBackWrap}>
                          <button
                            type="button"
                            className={styles.externalOrderBackBtn}
                            aria-label="Go back"
                            onClick={() => navigate(-1)}
                          >
                            <img width={20} height={20} src={back} alt="" />
                          </button>
                        </div>
                        <div className={styles.externalOrderHeaderCenter}>
                          <span className={styles.pickup_label2}>
                            Pickup Code
                          </span>
                          <div className={styles.externalOrderCode}>
                            {credentials.pickup_code}
                          </div>
                        </div>
                        <div
                          className={styles.externalOrderHeaderSpacer}
                          aria-hidden="true"
                        />
                      </div>
                      <Spin
                        className={styles.externalOrderSpin}
                        spinning={lockerBusy}
                        tip={lockerBusyTip || undefined}
                        size="large"
                      >
                        <div className={styles.externalOrderBody}>
                          <p className={styles.externalOrderMessage}>
                            {disableConfirmButton
                              ? `Locker #${credentials?.locker_number} is open`
                              : `Your order is in locker #${credentials?.locker_number}`}
                          </p>
                          <p className={styles.externalOrderMessageMuted}>
                            {disableConfirmButton
                              ? "Take your items, then confirm pickup below."
                              : "Tap Open Locker when you are at the locker. You can open it again if needed."}
                          </p>
                          <div
                            className={`${styles.externalOrderActions} ${
                              disableConfirmButton
                                ? styles.externalOrderActionsOpen
                                : ""
                            }`}
                          >
                            <button
                              type="button"
                              className={`${styles.externalOrderBtn} ${styles.externalOrderBtnPrimary}`}
                              disabled={lockerBusy}
                              onClick={() =>
                                HandleOpenLocker(credentials.locker_id)
                              }
                            >
                              {disableConfirmButton
                                ? "Re-open Locker"
                                : "Open Locker"}
                            </button>
                            {disableConfirmButton && (
                              <button
                                type="button"
                                disabled={lockerBusy}
                                className={`${styles.externalOrderBtn} ${styles.externalOrderBtnConfirm}`}
                                onClick={() =>
                                  HandleConfirmPickup(credentials?.locker_id)
                                }
                              >
                                Confirm Pickup
                              </button>
                            )}
                          </div>
                        </div>
                      </Spin>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default PickupExternalOrder;
